import React from 'react';
import { HStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import { useShopStyles } from '~/shared/styles';
import { Maybe } from '@springbig/shared/src/services/dutchie/schema-types';

export type PriceTagProps = {
    price: Maybe<number> | undefined;
    discountedPrice?: Maybe<number> | undefined;
    fontSize?: number;
};

export const PriceTag = ({
    price,
    discountedPrice,
    fontSize = 14,
}: PriceTagProps) => {

    const { button_background } = useShopStyles();

    return (
        <HStack space={1} alignItems={'baseline'} alignSelf={'flex-end'}>
            { !discountedPrice &&
                <Caption
                    fontSize={fontSize}
                    fontWeight={'bold'}
                    color={button_background}
                >
                    ${ price }
                </Caption>
            }
            { discountedPrice &&
                <Caption
                    fontSize={fontSize}
                    fontWeight={'bold'}
                    color={button_background}
                >
                    ${ discountedPrice }
                </Caption>
            }
        </HStack>
    );
};
